'use strict';

var RomSummaryFiltersPopupController = function RomSummaryFiltersPopupController($scope) {
  $scope.openFiltersPopup = false;
  $scope.filterLabels = {
    market: [{
      selected: true,
      value: 'KRK-BHX'
    }, {
      selected: false,
      value: 'BHX-AMS'
    }, {
      selected: false,
      value: 'AMS-LHR'
    }],
    SPOS: [{
      selected: true,
      value: 'EU'
    }, {
      selected: false,
      value: 'US'
    }, {
      selected: false,
      value: 'IN'
    }, {
      selected: false,
      value: 'AE'
    }],
    cabin: [{
      selected: true,
      value: 'Y'
    }, {
      selected: false,
      value: 'J'
    }, {
      selected: false,
      value: 'C'
    }],
    marketAnalyst: [{
      selected: false,
      value: 'Josephine Manjot'
    }, {
      selected: false,
      value: 'Sam Chamberlain'
    }, {
      selected: false,
      value: 'Angie Chang'
    }, {
      selected: false,
      value: 'Marcin Grabda'
    }, {
      selected: true,
      value: 'Tomasz Wasala'
    }],
    optWeeks: [{
      selected: false,
      value: '9/5'
    }, {
      selected: false,
      value: '9/12'
    }, {
      selected: false,
      value: '9/19'
    }, {
      selected: false,
      value: '9/26'
    }, {
      selected: false,
      value: '10/3'
    }],
    daysToDeparture: [{
      selected: false,
      value: '0-4'
    }, {
      selected: false,
      value: '5-10'
    }, {
      selected: false,
      value: '11-27'
    }, {
      selected: false,
      value: '28-68'
    }, {
      selected: false,
      value: '69-158'
    }],
    bookingsType: [{
      selected: false,
      value: 'Individual'
    }, {
      selected: false,
      value: 'Group'
    }]
  };
  $scope.selected = {
    market: ['KRK-BHX'],
    SPOS: ['EU'],
    cabin: ['Y'],
    marketAnalyst: ['Tomasz Wasala'],
    optWeeks: ['10/3'],
    daysToDeparture: ['69-158'],
    bookingsType: ['Individual', 'Group'],
    optDow: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  };
};
RomSummaryFiltersPopupController.$inject = ['$scope'];
module.exports = RomSummaryFiltersPopupController;